import React, { useContext } from "react";
import { useSelector } from "react-redux";
import documentsPageStyle from "../../assets/jss/xrs/views/documentsPageStyle";
import { primaryColor } from "assets/jss/xrs.js";

import { makeStyles } from "tss-react/mui";
import HeaderSectionLoggedID from "../SectionsPage/Sections/HeaderSectionLoggedID.js";
import DocumentSection from "../SectionsPage/Sections/DocumentSection.js";
import Context from "../../utils/context";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Box } from "@mui/material";

const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;
let drawerWidth = 150;
if (isMobile) {
  drawerWidth = 0;
}
const useStyles2 = makeStyles()((theme) => documentsPageStyle(theme));

export default function DocumentsPage() {
  const context = useContext(Context);
  const openCamera = useSelector((state) => state.CameraReducer.open);

  const { classes: classes2, cx } = useStyles2();

  if (openCamera) {
    return <DocumentSection></DocumentSection>;
  }
  return (
    <Box component="div" sx={{ backgroundColor: primaryColor[14] }}>
      <HeaderSectionLoggedID
        page="Documents"
        title="Documents"
      ></HeaderSectionLoggedID>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <main
            className={cx(classes2.content, {
              [classes2.contentShift]: context.stateDrawer,
            })}
          >
            <DocumentSection></DocumentSection>
          </main>
        </GridItem>
      </GridContainer>
    </Box>
  );
}
